import moment from 'moment';

export function dateFromISO(IsoDate) {
  const momentObj = moment(IsoDate);
  if (momentObj.isValid()) { return momentObj.format('DD.MM.YYYY HH:mm:ss'); }

  return false;
}

export function capitalize(string) {
  if (!string) return false;
  return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js